document.querySelectorAll('[data-office-gallery]').forEach(gallery=>{const buttons=[...gallery.querySelectorAll('[data-slide]')],slides=[...gallery.querySelectorAll('.ko-slide')],statuses=[...gallery.querySelectorAll('[data-office-status]')];const select=index=>{slides.forEach((slide,i)=>{slide.hidden=i!==index});buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));statuses.forEach((status,i)=>{status.hidden=i!==index})};buttons.forEach((button,index)=>{button.addEventListener('click',()=>select(index));button.addEventListener('keydown',event=>{if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;event.preventDefault();let next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;select(next);buttons[next].focus()})})});

document.querySelectorAll('[data-office-tabs]').forEach(group => {
  const tabs = [...group.querySelectorAll('[role="tab"]')];
  const panels = [...group.querySelectorAll('[role="tabpanel"]')];
  const select = index => {
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
    });
    panels.forEach((panel, i) => { panel.hidden = i !== index; });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index));
    tab.addEventListener('keydown', event => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      select(next);
      tabs[next].focus();
    });
  });
});


document.querySelectorAll('.ko-product-form').forEach(form => {
  const selector = form.querySelector('[data-office-variant]');
  if (!selector) return;
  const detail = form.closest('.ko-detail');
  const price = detail?.querySelector('[data-office-price]');
  const quantity = form.elements.quantity;
  const add = form.querySelector('[data-office-add]');
  const availability = form.querySelector('[data-office-availability]');
  const payment = form.querySelector('[data-office-payment]');
  const update = () => {
    const option = selector.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    add.disabled = !available;
    add.textContent = available ? add.dataset.addLabel : add.dataset.unavailableLabel;
    if (available) add.removeAttribute('aria-describedby');
    else add.setAttribute('aria-describedby', 'ko-purchase-note');
    availability.hidden = available;
    quantity.disabled = !available;
    quantity.min = option?.dataset.min || '1';
    quantity.step = option?.dataset.step || '1';
    if (option?.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    if (!quantity.checkValidity()) quantity.value = quantity.min;
    if (payment) payment.hidden = !available;
  };
  selector.addEventListener('change', update);
  update();
});
